import { createSlice } from '@reduxjs/toolkit';
export const instanceSlice = createSlice({
  name: 'instances',
  initialState: [],
  reducers: {
    selectInstance: (state, { payload }) => {
      const { index } = payload;
      const selected = state.find((i) => i.is_selected === true);

      selected.is_selected = false;
      state[index].is_selected = true;
    },
    updateInstanceMatrix: (state, { payload }) => {
      const selectedIndex = state.findIndex((i) => i.is_selected === true);
      state[selectedIndex].state.matrix = payload;
    },
  },
});

export const { selectInstance, updateInstanceMatrix } = instanceSlice.actions;

export default instanceSlice.reducer;

export const instancesSelector = (state) => state.instances;
